import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import axios from 'axios';
import { CANCEL } from 'redux-saga';
import { CANONICAL_XHR_PUPPY_ENDPOINT, LATEST_VERSION, LOCAL_XHR_PUPPY_ENDPOINT } from './constants';
export function isApiError(response) {
    return response.error || response.errorCode;
}
/**
 * GET requests use `params`, POST requests use `data`. This function maps the necessary globally relevant
 * arguments to either of those keys.
 */ export function configureBaseRequestArguments(argumentsKey, options, globalArguments) {
    if (options[argumentsKey] === undefined) {
        options[argumentsKey] = {};
    }
    if (!options[argumentsKey].da_minor_version) {
        options[argumentsKey].da_minor_version = LATEST_VERSION;
    }
    options[argumentsKey]['csrf_token'] = globalArguments.csrfToken;
    return options;
}
export function configureOptions(options, globalArguments) {
    return configureBaseRequestArguments(options.method && options.method.toLowerCase() === 'post' ? 'data' : 'params', options, globalArguments);
}
export function configurePuppyOptions(options, globalArguments, papiBase) {
    // Puppy needs the
    if (papiBase) {
        options.url = `${papiBase}/${options.url}`.replace(/\/{2,}/g, '/');
    }
    // Routing
    // local dev hits local nodejs proxy to deal with http -> https
    // vm hits vm
    // canonical hits puppy
    if (options.baseURL === undefined) {
        // Handle prod vs local endpoint routing
        if (process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm') {
            options.baseURL = `${window.location.origin}/_puppy/`;
        // Local full docker helper
        } else if (window['__XHR_LOCAL__']) {
            options.baseURL = LOCAL_XHR_PUPPY_ENDPOINT;
        // Production goes to the xhr server
        } else {
            options.baseURL = CANONICAL_XHR_PUPPY_ENDPOINT;
        }
    }
    return configureOptions(options, globalArguments);
}
export function getApiResponse(options) {
    const cancelTokenSource = axios.CancelToken.source();
    const promise = axios.request(options.enableCancellation ? _object_spread_props(_object_spread({}, options), {
        cancelToken: cancelTokenSource.token
    }) : options).then((response)=>{
        return response.data;
    }).catch((e)=>{
        var _e_response, _e_response1;
        var _e_response_status;
        // This deals with some legacy issues, we used to have node translate 400
        // to 200 because really papi should return user handleable errors as 200
        // but as it doesn't we have to do some special handling. Logic is if its
        // a 500 return false, otherwise return the error so it can be used by
        // isApiError and displayed to the user. For 500s, we generally do
        // !response before the isApiError check, so this should give us the same
        // execution as before puppy migrations. Maybe in the future we can actually
        // address our error handling once and for all...
        if (((_e_response_status = (_e_response = e.response) === null || _e_response === void 0 ? void 0 : _e_response.status) !== null && _e_response_status !== void 0 ? _e_response_status : 500) >= 500) {
            return false;
        }
        return (_e_response1 = e.response) === null || _e_response1 === void 0 ? void 0 : _e_response1.data;
    });
    // redux saga calls this special prop when it cancel the outer saga E.g. takeLatest
    if (options.enableCancellation) {
        promise[CANCEL] = ()=>cancelTokenSource.cancel();
    }
    return promise;
}
export function getFakeResponse(response) {
    if (process.env.NODE_ENV === 'test') {
        return response;
    }
    return new Promise((resolve)=>{
        setTimeout(()=>resolve(response), 1000);
    });
}

//# sourceMappingURL=base.js.map